(() => {
  const allowedExtension = /\.(pdf|dwg|xlsx?|docx?|jpe?g|png)$/i;
  const maxFileSize = 100 * 1024 * 1024;
  const fileIcon = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><path d="M14 2v6h6"/></svg>';
  const closeIcon = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg>';
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function formatSize(bytes) {
    if (bytes < 1024 * 1024) return `${Math.max(1, Math.round(bytes / 1024))} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  }

  function fileCount(count) {
    return `${count} ${count === 1 ? 'file' : 'files'}`;
  }

  function initialize(root) {
    if (root.dataset.homeQuoteReady || !window.ExcelQuoteSubmit) return;
    root.dataset.homeQuoteReady = 'true';

    const card = root.querySelector('[data-quote-card]');
    const input = root.querySelector('[data-quote-files]');
    const dropzone = root.querySelector('[data-quote-dropzone]');
    const status = root.querySelector('[data-quote-status]');
    const fileList = root.querySelector('[data-quote-file-list]');
    const selectionNote = root.querySelector('[data-quote-selection-note]');
    const summary = root.querySelector('[data-quote-step-two-files]');
    const uploadTypes = root.querySelector('[data-quote-upload-types]');
    const firstStep = root.querySelector('[data-quote-step="1"]');
    const secondStep = root.querySelector('[data-quote-step="2"]');
    const next = root.querySelector('[data-quote-next]');
    const back = root.querySelector('[data-quote-back]');
    const form = root.querySelector('[data-quote-form]');
    const detailsTitle = root.querySelector('[data-quote-details-title]');
    const selected = [];
    let dragDepth = 0;
    let swapping = false;

    window.ExcelQuoteSubmit.attach(root, () => selected);

    function announce(message, error = false) {
      status.textContent = message;
      status.hidden = !message;
      status.toggleAttribute('data-error', error);
    }

    function chip(file) {
      const item = document.createElement('li');
      item.className = 'ehq__chip';
      const icon = document.createElement('span');
      icon.className = 'ehq__chip-icon';
      icon.innerHTML = fileIcon;
      const name = document.createElement('span');
      name.className = 'ehq__chip-name';
      name.textContent = file.name;
      name.title = file.name;
      const size = document.createElement('span');
      size.className = 'ehq__chip-size';
      size.textContent = formatSize(file.size);
      item.append(icon, name, size);
      return item;
    }

    function renderFiles() {
      fileList.replaceChildren();
      summary.replaceChildren();
      fileList.hidden = selected.length === 0;
      if (selectionNote) selectionNote.hidden = selected.length === 0;
      next.hidden = selected.length === 0;

      selected.forEach((file, index) => {
        const item = chip(file);
        const remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'ehq__chip-remove';
        remove.innerHTML = closeIcon;
        remove.setAttribute('aria-label', `Remove ${file.name}`);
        remove.addEventListener('click', () => {
          selected.splice(index, 1);
          renderFiles();
          announce(selected.length ? `${fileCount(selected.length)} selected.` : 'No files selected.');
          const remaining = fileList.querySelectorAll('button');
          (remaining[Math.min(index, remaining.length - 1)] || input).focus();
        });
        item.append(remove);
        fileList.append(item);
        summary.append(chip(file));
      });
    }

    function addFiles(files) {
      if (root.dataset.quoteSending || root.dataset.quoteSubmitted) return;
      const errors = [];
      Array.from(files).forEach((file) => {
        if (!allowedExtension.test(file.name)) {
          errors.push(`${file.name}: choose a PDF, DWG, XLS, DOC, JPG or PNG file.`);
        } else if (file.size > maxFileSize) {
          errors.push(`${file.name}: exceeds the 100 MB limit.`);
        } else if (!file.size) {
          errors.push(`${file.name}: the file is empty.`);
        } else if (!selected.some((item) => item.name === file.name && item.size === file.size && item.lastModified === file.lastModified)) {
          selected.push(file);
        }
      });
      input.value = '';
      renderFiles();
      announce(errors.length ? errors.join(' ') : `${fileCount(selected.length)} selected. Continue to add your project details.`, errors.length > 0);
    }

    // Fade the current step out, grow or shrink the card to the next step's height,
    // then let the next step's rows rise in one after another.
    function swapSteps(from, to, onShown) {
      if (swapping) return;
      const showDetails = to === secondStep;

      if (reduceMotion.matches) {
        from.hidden = true;
        to.hidden = false;
        uploadTypes.hidden = showDetails;
        onShown();
        return;
      }

      swapping = true;
      const startHeight = card.offsetHeight;
      if (showDetails) uploadTypes.classList.add('is-faded');
      from.classList.add('is-leaving');
      from.addEventListener('animationend', function leave(event) {
        if (event.target !== from) return;
        from.removeEventListener('animationend', leave);
        from.hidden = true;
        from.classList.remove('is-leaving');
        to.hidden = false;
        secondStep.classList.toggle('is-entering', showDetails);
        uploadTypes.hidden = showDetails;

        const endHeight = card.offsetHeight;
        card.style.height = `${startHeight}px`;
        card.classList.add('is-resizing');
        card.getBoundingClientRect();
        card.style.height = `${endHeight}px`;

        const finish = () => {
          card.classList.remove('is-resizing');
          card.style.height = '';
          if (!showDetails) uploadTypes.classList.remove('is-faded');
          swapping = false;
        };
        card.addEventListener('transitionend', function done(event) {
          if (event.target !== card) return;
          card.removeEventListener('transitionend', done);
          finish();
        });
        if (startHeight === endHeight) finish();
        onShown();
      });
    }

    input.addEventListener('change', () => addFiles(input.files));
    dropzone.addEventListener('dragenter', (event) => {
      event.preventDefault();
      dragDepth += 1;
      dropzone.classList.add('is-dragging');
    });
    dropzone.addEventListener('dragover', (event) => {
      event.preventDefault();
      if (event.dataTransfer) event.dataTransfer.dropEffect = 'copy';
    });
    dropzone.addEventListener('dragleave', (event) => {
      event.preventDefault();
      dragDepth -= 1;
      if (dragDepth <= 0) {
        dragDepth = 0;
        dropzone.classList.remove('is-dragging');
      }
    });
    dropzone.addEventListener('drop', (event) => {
      event.preventDefault();
      dragDepth = 0;
      dropzone.classList.remove('is-dragging');
      if (event.dataTransfer) addFiles(event.dataTransfer.files);
    });

    next.addEventListener('click', () => {
      if (!selected.length) {
        announce('Choose at least one file before continuing.', true);
        input.focus();
        return;
      }
      swapSteps(firstStep, secondStep, () => {
        detailsTitle.focus({ preventScroll: true });
        if (card.getBoundingClientRect().top < 0) {
          card.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'start' });
        }
      });
    });
    back.addEventListener('click', () => {
      swapSteps(secondStep, firstStep, () => next.focus({ preventScroll: true }));
    });
  }

  const initializeAll = () => document.querySelectorAll('[data-home-quote]').forEach(initialize);
  document.addEventListener('excel:quote-submit-ready', initializeAll);
  initializeAll();
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-home-quote]').forEach(initialize);
  });
})();
